// @ts-nocheck 
import {Inject} from "@atypon/ui-utils"
import  FormValidation from '../../../utility/validation';
export default class AlertSignUp {

    @Inject()
    protected formValidation:FormValidation

    classList = {
        spinner: 'js--loading',
        show: 'js--show',
        hide: 'hidden',
        opened: 'js--opened',
        required: 'js-required'
    };

    html = {
        spinner: '<div class="js--loading" aria-label="loading results" role="alert"></div>',
        successAlert: `
                    <div class="alert-sign-up__box alert-success">
                        <i aria-hidden="true" class="icon-email-check"></i>
                        <div class="alert-sign-up__content">
                            <p>Successfully signed up to email alerts.</p>
                            <a href="/action/showPreferences?menuTab=Alerts" class="manage-alerts-link small">Manage your alerts</a>
                        </div>
                    </div>
        `,
    };

    selectors = {
        alertSignUpLink: '.alert-sign-up__link',
        alertSignUpSection: '.alert-sign-up',
        alertSignUpForm: '.alert-sign-up__form',
        alertVerifyEmail: '.alert-verify-email',
        alertUnVerifyEmail: '.alert-unVerify-email',
        alertSignUpBox: '.alert-sign-up__box',
        userEmail: 'input[name="email"]',
        userLocation: '#alert-user-location',
        formExtra: '.alert-sign-up__form-extra',
        formExtraInner: '.alert-sign-up__form-extra .inner',
        recaptcha: '.g-recaptcha',
        formFooter: '.alert-sign-up__form-footer',
        formCollapse: '.alert-sign-up__form-collapse',
        continueBtn: '.continue-btn',
        verifyEmailBtn: '.verify-email-btn',
        emailAddress: '.email-address',
        emailRequiredMark: '.email-required-mark',
        errorMsg: '#marketableError',
        contactSupport: '.text-reset',
        piplCheckbox: '.pipl-checkbox',
        piplInput: 'input[name="acceptPIPLConsent"]',
    };

    elements = {
        alertSignUpLink: null,
        alertSignUpSection: null,
        alertSignUpForm: null,
        alertVerifyEmail: null,
        alertUnVerifyEmail: null,
        alertSignUpBox: null,
        userEmail: null,
        userLocation: null,
        formExtra: null,
        formExtraInner: null,
        recaptcha: null,
        formFooter: null,
        formCollapse: null,
        continueBtn: null,
        verifyEmailBtn: null,
        emailAddress: null,
        emailRequiredMark: null,
        contactSupport: null,
        piplCheckbox: null,
        piplInput: null,
    };

    flags = {
        isPIPLEnabled: null,
        chinaSelected: null,
        isRegionChina: null,
        noSelection: null,
    };

    setElements() {
        this.elements.alertSignUpLink = document.querySelector(this.selectors.alertSignUpLink);
        this.elements.alertSignUpSection = document.querySelector(this.selectors.alertSignUpSection);
        this.elements.alertSignUpForm = this.elements.alertSignUpSection.querySelector(this.selectors.alertSignUpForm);
        this.elements.alertVerifyEmail = this.elements.alertSignUpSection.querySelector(
            this.selectors.alertVerifyEmail
        );
        this.elements.alertUnVerifyEmail = this.elements.alertSignUpSection.querySelector(
            this.selectors.alertUnVerifyEmail
        );
        this.elements.alertSignUpBox = this.elements.alertSignUpSection.querySelector(this.selectors.alertSignUpBox);
        this.elements.userEmail = this.elements.alertSignUpSection.querySelector(this.selectors.userEmail);
        this.elements.userLocation = this.elements.alertSignUpSection.querySelector(this.selectors.userLocation);
        this.elements.formExtra = this.elements.alertSignUpSection.querySelector(this.selectors.formExtra);
        this.elements.formExtraInner = this.elements.alertSignUpSection.querySelector(this.selectors.formExtraInner);
        this.elements.recaptcha = this.elements.alertSignUpSection.querySelector(this.selectors.recaptcha);
        this.elements.formFooter = this.elements.alertSignUpSection.querySelector(this.selectors.formFooter);
        this.elements.formCollapse = this.elements.alertSignUpSection.querySelector(this.selectors.formCollapse);
        this.elements.continueBtn = this.elements.alertSignUpSection.querySelector(this.selectors.continueBtn);
        this.elements.verifyEmailBtn = this.elements.alertSignUpSection.querySelector(this.selectors.verifyEmailBtn);
        this.elements.emailAddress = this.elements.alertSignUpSection.querySelector(this.selectors.emailAddress);
        this.elements.emailRequiredMark = this.elements.alertSignUpSection.querySelector(this.selectors.emailRequiredMark);
        this.elements.contactSupport = this.elements.alertSignUpSection.querySelector(this.selectors.contactSupport);
        this.elements.piplCheckbox = this.elements.alertSignUpSection.querySelector(this.selectors.piplCheckbox);
        this.elements.piplInput = this.elements.piplCheckbox?.querySelector(this.selectors.piplInput);
    }

    setFlags() {
        this.flags.isPIPLEnabled = this.elements.piplCheckbox?.getAttribute('data-pipl-feature-enabled');
    }

    constructor() {
        this.init();
    }

    init() {
        this.setElements();
        this.setFlags();
        this.eventListeners();
        this.flags.isPIPLEnabled && this.chinaPipleViewer();
    }

    eventListeners() {
        this.elements.verifyEmailBtn?.addEventListener('click', this.requestVerifyEmail);
        this.elements.continueBtn?.addEventListener('click', this.expandExtraElements, {once: true});
        this.elements.alertSignUpForm?.addEventListener('submit', this.formSubmit.bind(this));
        this.elements.alertSignUpLink?.addEventListener('click', this.signUpForEmailAlerts);
        this.elements.contactSupport?.addEventListener('click', e => this.handleContactSupport(e), {once: true});
        this.flags.isPIPLEnabled && this.elements.userLocation.addEventListener('change', this.chinaSelectHandler);
    }

    expandExtraElements = () => {
        if (!this.elements.formExtra.classList.contains(this.classList.opened)) {
            this.elements.formExtra.classList.add(this.classList.opened);
            this.elements.formCollapse.classList.add(this.classList.hide);
            this.elements.formFooter.classList.remove(this.classList.hide);
            this.elements.userEmail.value === '' ? this.elements.userEmail.focus() : this.elements.userLocation.focus();
            this.elements.userEmail.classList.add(this.classList.required);
            this.elements.userEmail.setAttribute('aria-required', 'true');
            this.elements.emailRequiredMark.classList.remove('hidden');

            setTimeout(() => {
                this.handleFormExtraHeight();
            }, 50);
        }
    };

    handleFormExtraHeight = () => {
        this.elements.formExtra.querySelector(this.selectors.errorMsg)
            ? (this.elements.formExtra.style.maxHeight = `${this.elements.formExtraInner.offsetHeight + 100}px`)
            : (this.elements.formExtra.style.maxHeight = `${this.elements.formExtraInner.offsetHeight + 20}px`);
    }

    chinaPipleViewer = () => {
        this.flags.isRegionChina = this.elements.piplCheckbox.getAttribute('data-pipl-china');
        this.chinaCheckboxViewer(this.flags.isPIPLEnabled, this.flags.isRegionChina);
        this.chinaSelectHandler();
    };

    chinaSelectHandler = () => {
        this.flags.chinaSelected =
            this.elements.userLocation.options[this.elements.userLocation.selectedIndex].text.toLowerCase() === 'china';
        this.flags.noSelection =
            this.elements.userLocation.options[this.elements.userLocation.selectedIndex].getAttribute('disabled') ===
            'disabled';
        this.chinaCheckboxViewer(
            this.flags.isPIPLEnabled,
            this.flags.chinaSelected || (this.flags.isRegionChina && this.flags.noSelection)
        );
    };

    chinaCheckboxViewer = (piplEnabled, china) => {
        if (piplEnabled && china) {
            this.elements.piplCheckbox.style.display = 'block';
            this.elements.piplInput.setAttribute('required', true);
            this.flags.isRegionChina
                ? (this.elements.formExtra.style.maxHeight = '578px')
                : (this.elements.formExtra.style.maxHeight = `${
                      this.elements.formExtra.offsetHeight + this.elements.piplCheckbox.offsetHeight
                  }px`);
        } else if (!this.flags.isRegionChina) {
            this.elements.piplCheckbox.style.display = 'none';
            this.elements.piplInput.removeAttribute('required');
        }
    };

    formSubmit(e) {
        e.preventDefault();         
        if (this.formValidation.validate(e)) {
            this.handleFormExtraHeight();
            return
        }
        let formAction = e.target.action,
            formData = new FormData(e.target),
            formSerialize = new URLSearchParams(formData).toString(),
            url = `${formAction}&${formSerialize}&submit=true`;

        if (url.includes('=on')) {
            url = url.replaceAll('=on', '=true');
        } else if (url.includes('=off')) {
            url = url.replaceAll('=off', '=false');
        }
        this.elements.alertSignUpSection.classList.add('js--loading');
        fetch(url)
            .then(response => response.text())
            .then(this.widgetRebuilding)
            .then(() => {
                this.elements.formExtra?.querySelector(this.selectors.errorMsg) && this.expandExtraElements();
                !this.elements.formExtra?.querySelector(this.selectors.errorMsg) &&
                    window.adobeDataLayer &&
                    UX.adobeDigitalData.eTOCEvents.submitForm();
                this.elements.alertSignUpSection.querySelector(this.selectors.alertUnVerifyEmail) &&
                    window.adobeDataLayer &&
                    UX.adobeDigitalData.eTOCEvents.requestVerificationShown();
            });
    }

    widgetRebuilding = data => {
        let parsedHtml = UX.utils.parseHtml(data).querySelector("#etoc-signup").innerHTML
        this.elements.alertSignUpSection.classList.remove('js--loading');
        this.elements.alertSignUpSection.innerHTML=parsedHtml;
        this.init();
        this.recaptchaReInit();
    };

    recaptchaReInit() {
        if (this.elements.recaptcha) {
            const recaptchaSrc = this.elements.recaptcha.previousElementSibling.src,
                headScripts = document.head.querySelectorAll(`script[src="${recaptchaSrc}"]`),
                script = document.createElement('script');

            if (headScripts.length) headScripts.forEach(script => script.remove());
            script.type = 'text/javascript';
            if (recaptchaSrc) {
                script.src = recaptchaSrc;
                document.head.append(script);
            }
        }
    }

    requestVerifyEmail = () => {
        window.adobeDataLayer && UX.adobeDigitalData.eTOCEvents.requestVerification();
        const requestURL = this.elements.verifyEmailBtn.getAttribute('data-url'),
            hideAlertUnVerifyEmail = data => {
                this.elements.alertSignUpSection.innerHTML = `
                    <div class="alert-sign-up__box alert-warning alert-verify-email" tabindex="0">
                        <img src="/products/pericles/releasedAssets/images/email-alert.svg" alt="email alert" class="email-alert">
                        <div class="alert-sign-up__content">
                            <h3>Please verify your email to begin receiving alerts.</h3>
                            <p class="confirmation-message">
                                An email has been sent to
                                <strong class="email-address">${data.email}</strong>
                                with a link to verify your email address and begin receiving alerts.
                            </p>
                            <span class="small">If you do not receive an email within 24 hours please check your email junk/spam folder or try signing up again.</span>
                        </div>
                    </div>`;

                this.elements.alertSignUpBox?.focus();
            };

        $.ajax({
            type: 'GET',
            url: requestURL,
            success: function (data) {
                if (data.result === 0) hideAlertUnVerifyEmail(data);
            },
            error: function (data) {
                console.log(data.message); // eslint-disable-line no-console
            },
        });
    };

    showSuccessAlert = () => {
        this.elements.alertSignUpSection.innerHTML = this.html.successAlert;
        window.adobeDataLayer && UX.adobeDigitalData.eTOCEvents.successCTA();
    };

    signUpForEmailAlerts = e => {
        e.preventDefault();
        const subscribeLink = this.elements.alertSignUpLink.getAttribute('href');
        fetch(subscribeLink)
            .then(res => {
                if (res.url.includes('redirect')) {
                    window.location.href = res.url;
                } else {
                    this.showSuccessAlert();
                }
            })
            .catch(err => console.log(err.message)); // eslint-disable-line no-console
    };

    handleContactSupport = e => {
        e.preventDefault();
        window.adobeDataLayer && UX.adobeDigitalData.eTOCEvents.contactSupport();
        window.location.href = e.currentTarget.getAttribute('href');
    };
}
